import type { ReactElement } from 'react';

import SkeletonLine from './SkeletonLine';
import SkuGallerySkeleton from './SkuGallerySkeleton';

function Skeleton(): ReactElement {
  return (
    <div className="c-order c-order--skeleton">
      <div className="c-order__content">
        <div className="c-order__header">
          <div className="c-skeleton-circle" />
          <div className="c-order__title c-order__title--upcoming-menu">
            <div>
              <SkeletonLine width={200} className="d-block d-sm-none" />
              <SkeletonLine width={160} className="d-none d-lg-block" />
              <SkeletonLine width={200} />
            </div>
          </div>
          <div className="c-order__skip">
            <SkeletonLine width={60} className="d-block d-sm-none" />
            <SkeletonLine width={220} className="d-none d-sm-block" />
          </div>
        </div>
        <div className="c-order__plan d-flex d-lg-none">
          <div>
            <SkeletonLine width={180} />
          </div>
          <div className="c-order__change-meals">
            <SkeletonLine width={120} />
          </div>
        </div>
        <SkuGallerySkeleton />
      </div>
    </div>
  );
}

export default Skeleton;
